import { createWithEqualityFn } from 'zustand/traditional'
import axios from 'axios'

interface MembershipStore {
	data: any[]
	getAll: () => Promise<{ success: boolean; data: any[] }>
	purchase: (data: any) => Promise<{ success: boolean; data: any }>
	checkPromptpayResult: (paymentId: string) => Promise<{ success: boolean; data: any }>
	clearState: () => void
}

export const API_SLUG = '/membership-supplier-package'

export const useMembershipStore = createWithEqualityFn<MembershipStore>(
	set => ({
		data: [],
		getAll: async () => {
			return axios
				.get(API_SLUG)
				.then(res => {
					set({ data: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				})
		},
		purchase: async data => {
			return axios
				.post(`${API_SLUG}/purchase`, data)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				})
		},
		checkPromptpayResult: async paymentId => {
			return axios
				.get(`${API_SLUG}/prompt-pay/check/${paymentId}`)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				})
		},
		clearState: () => {
			set({ data: [] })
		},
	}),
	Object.is
)
